import React from "react";
import { SITES } from "../../types/Emailstypes";
import SiteCard from "./SiteCard";

interface SiteSelectorProps {
  selectedSiteId: string | null;
  onSelect: (id: string) => void;
  onConfirm: (id: string) => void; 
}

const SiteSelector: React.FC<SiteSelectorProps> = ({
  selectedSiteId,
  onSelect,
  onConfirm,
}) => {
  const selectedSite = SITES.find((s) => s.id === selectedSiteId);

   const handleClick = (id: string) => {
    onSelect(id);
    onConfirm(id);
  };

  return (
    <div className="animate-fade-in">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-slate-800 tracking-tight">
          Choisissez un site
        </h2>
        <p className="mt-1 text-sm text-slate-400">
          Sélectionnez le site dont vous souhaitez gérer les fiches GBP.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
        {SITES.map((site, i) => (
          <div
            key={site.id}
            style={{ animationDelay: `${i * 40}ms` }}
            className="animate-fade-in"
          >
            <SiteCard
              site={site}
              selected={selectedSiteId === site.id}
              onClick={() => handleClick(site.id)}
            />
          </div>
        ))}
      </div>

       {selectedSiteId && (
        <div className="mt-5 sm:hidden">
          <button
            onClick={() => onConfirm(selectedSiteId)}
            className="w-full inline-flex items-center justify-center gap-2 rounded-xl px-5 py-3
              text-sm font-bold text-white shadow-md transition-all duration-150 active:scale-[0.98]"
            style={{ backgroundColor: selectedSite?.color ?? "#0F52BA" }}
          >
            Continuer avec {selectedSite?.label}
          </button>
        </div>
      )}
    </div>
  );
};

export default SiteSelector;